import PaymentIntegration from '../model/paymentIntegration'
import { RequestResponse, secureRequest, url } from '../utils/request-utils'

export function fetchCompanyPaymentIntegrations(companyID: string): Promise<RequestResponse<PaymentIntegration[]>> {
  return secureRequest('GET', url('/v2/companyPaymentIntegrations', { companyID }))
}
